import 'rxjs';
import { combineEpics } from 'redux-observable';
import { epics as appEpics } from './app/actions';
import { epics as authEpics } from './auth/actions';
import { epics as usersEpics } from './users/actions';
import { epics as propertiesEpics } from './properties/actions';

const epics = [
  ...appEpics,
  ...authEpics,
  ...usersEpics,
  ...propertiesEpics,
];

const configureEpics = deps => (action$, { getState }) =>
  combineEpics(...epics)(action$, { ...deps, getState });

export default configureEpics;



// WEBPACK FOOTER //
// ./src/common/configureEpics.js